import { kpiApi } from "@/api/kpiApi";
import Loading from "@/components/feedback/Loading";
import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import { Navigate, useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import KpiEditResultForm from "./KpiEditResultForm";

const pageTitle = "Edit result";

function transformKpiToEditResultInitialValues(segment) {
    const { data_records: dataRecords } = segment;
    const data = dataRecords?.map((data) => ({
        timeframeYear: data.timeframe_year,
        resultValue: data.result_value_json?.value ?? "",
        noResult: !Boolean(data.result_value_json),
    }));

    return {
        reportResults: data ?? [],
    };
}

// TODO: copy from KPIsExpectedResultForm
export default function KpiEditResult(props) {
    const [searchParams] = useSearchParams({ segmentId: null });
    const segmentId = parseInt(searchParams.get("segmentId"));
    const { kpi } = useOutletContext();
    const kpiData = kpi?.data?.data;
    const kpiId = kpiData?.id;

    const editKpiResultForm = kpiApi.endpoints.getEditExpectedResultForm.useQuery({
        kpiId: kpiId,
        kpiDataSegmentId: segmentId,
    });
    //useUpdateKpiDataSegmentResultMutation
    const [updateKpiResult] = kpiApi.endpoints.updateKpiDataSegmentResult.useMutation();
    const handleSubmit = (values) =>
        updateKpiResult({
            kpiId: kpiId,
            kpiDataSegmentId: segmentId,
            data: values,
        });
    const navigate = useNavigate();
    const handleClose = () => navigate(-1);

    // HOC guard
    if (!segmentId || editKpiResultForm.isError) {
        return <Navigate to="/404" replace={true} />;
    }
    if (editKpiResultForm.isLoading) {
        return <Loading />;
    }

    const segment = editKpiResultForm.data?.data?.kpi_data_segments[0];
    const formTitle = `Segment: ${segment?.data_segment_title} (${segment.data_unit})`;

    return (
        <Card variant="outlined">
            <CardHeader title={pageTitle}></CardHeader>

            <Divider variant="middle" />

            <CardContent sx={{ padding: 2 }}>
                <KpiEditResultForm
                    title={formTitle}
                    initialValues={transformKpiToEditResultInitialValues(segment)}
                    onSubmit={handleSubmit}
                    onClose={handleClose}
                />
            </CardContent>
        </Card>
    );
}
